/* eslint-disable func-names */
import React, { Component } from "react";
import { connect } from "react-redux";
import { getTKT1C3DInfos, getTKT1TrustedPersonInfos, updateTKT1C3DInfo } from '../actions';
import ScrollToTop from "react-scroll-to-top";
import Pagination from "../components/Pagination";
import { CONFIGS } from "../configs";
import { getTranslate, LANGUAGE_KEYS } from "../utils";
import queryString from 'query-string';
import {
  Badge,
  Button,
  Card,
  Form,
  Table,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  InputGroup,
  Modal
} from "react-bootstrap";
import { FaTimes, FaEye, FaEdit, FaTrash, FaCopy, FaExternalLinkAlt } from 'react-icons/fa';
import Select from 'react-select';
import C3DInfoModal from '../components/C3DInfoModal/C3DInfoModal';
import TrustedPersonInfoModal from '../components/TrustedPersonInfoModal/TrustedPersonInfoModal';
import IframeModal from '../components/IframeModal/IframeModal';
import { getApiUrl } from '../utils/platform';
import { getToken } from '../utils/token';

class TKT1ValidC3D extends Component {
  initQuery = {
    currentPage: 1,
    itemsPerPage: 500,
    sortBy: 'ref_trusted_person_mid',
    sortOrder: 1,
    search: '',
    relation_with: '',
    trusted_person_id: '',
    tax_city_filter: ''
  }

  initShowColumns = {
    full_name: true,
    full_name_english: true,
    c3d_number: true,
    c3d_dob: true,
    c3d_sex: true,
    c3d_place_of_origin: false,
    c3d_place_of_residence: true,
    c3d_city: false,
    tax_city: true,
    source: false,
    info_etsy_status: false,
    ref_trusted_person_mid: true,
    ref_etsy_info_pack_mid: true,
    cmt_number: false,
    c3d_issue_date: false,
    c3d_expired_date: false
  }

  constructor() {
    super();
    this.state = {
      query: this.initQuery,
      showColumns: this.initShowColumns,
      loading: false,
      showConfigModal: false,
      allTrustedPersonOptions: [], // Store all options
      trustedPersonOptions: [], // Filtered options
      relationOptions: [],
      taxCityOptions: [], // Available tax cities
      allC3DInfos: [], // Store all C3D data for client-side filtering
      showEditModal: false,
      showViewModal: false,
      selectedC3DInfo: null,
      isEditMode: false,
      showIframeModal: false,
      iframeUrl: '',
      iframeTitle: '',
      showTrustedPersonModal: false,
      selectedTrustedPersonInfo: null
    };
  }

  componentDidMount() {
    document.title = 'TKT1 Valid C3D';
    
    // Load view config from localStorage
    const viewConfig = JSON.parse(localStorage.getItem('TKT1ValidC3D_ViewConfig'));
    
    // Load itemsPerPage from localStorage
    const savedItemsPerPage = JSON.parse(localStorage.getItem('TKT1ValidC3D_itemsPerPage'));
    
    if (viewConfig || savedItemsPerPage) {
      this.setState(prevState => ({
        showColumns: {
          ...this.initShowColumns,
          ...(viewConfig || {})
        },
        query: {
          ...prevState.query,
          itemsPerPage: savedItemsPerPage || this.initQuery.itemsPerPage
        }
      }));
    }
    
    // Load trusted person options and relation options together
    this.loadTrustedPersonAndRelationOptions();
    
    // Load initial data
    this.loadData();
  }

  loadTrustedPersonAndRelationOptions = () => {
    const query = {
      currentPage: 1,
      itemsPerPage: 1000, // Get all trusted persons
      sortBy: 'MID',
      sortOrder: 1
    };
    
    this.props.getTKT1TrustedPersonInfos(query).then(() => {
      const { trustedPersonInfos } = this.props;
      if (trustedPersonInfos && Array.isArray(trustedPersonInfos)) {
        // Create trusted person options with relation_with data, sorted by MID
        const allTrustedPersonOptions = trustedPersonInfos
          .map(person => ({
            value: person._id,
            label: person.full_name,
            mid: person.MID,
            relation_with: person.relation_with
          }))
          .sort((a, b) => {
            // Sort by MID alphabetically
            if (a.mid < b.mid) return -1;
            if (a.mid > b.mid) return 1;
            return 0;
          });
        
        // Extract unique relation_with values from the same data
        const uniqueRelations = [...new Set(
          trustedPersonInfos
            .map(person => person.relation_with)
            .filter(relation => relation && relation.trim()) // Filter out null/empty values
        )].sort();
        
        const relationOptions = uniqueRelations.map(relation => ({
          value: relation,
          label: relation
        }));
        
        this.setState({
          allTrustedPersonOptions,
          trustedPersonOptions: allTrustedPersonOptions, // Initially show all
          relationOptions
        });
      }
    });
  }

  loadData = () => {
    const apiQuery = this.prepareApiQuery(this.state.query);
    this.props.getTKT1C3DInfos(apiQuery).then(() => {
      // Update tax city options after data is loaded
      const { c3dInfos } = this.props;
      if (c3dInfos && Array.isArray(c3dInfos)) {
        const taxCityOptions = this.extractTaxCityOptions(c3dInfos);
        this.setState({ taxCityOptions });
      }
    });
  }

  handleChangeSearch = (e) => {
    this.setState({
      query: { ...this.state.query, search: e.target.value }
    })
  }

  handleClearSearch = () => {
    this.setState({
      query: { ...this.state.query, search: '' }
    }, () => {
      this.handleSearch();
    })
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleSearch();
    }
  }

  handleRelationChange = (e) => {
    const selectedRelation = e.target.value;
    const newQuery = { 
      ...this.state.query, 
      relation_with: selectedRelation,
      trusted_person_id: '' // Reset trusted person selection when relation changes
    };
    
    // Filter trusted person options based on selected relation
    let filteredTrustedPersonOptions = this.state.allTrustedPersonOptions;
    if (selectedRelation && selectedRelation.trim()) {
      filteredTrustedPersonOptions = this.state.allTrustedPersonOptions
        .filter(person => person.relation_with === selectedRelation)
        .sort((a, b) => {
          // Keep sorted by MID after filtering
          if (a.mid < b.mid) return -1;
          if (a.mid > b.mid) return 1;
          return 0;
        });
    }
    
    this.setState({ 
      query: newQuery,
      trustedPersonOptions: filteredTrustedPersonOptions
    }, () => {
      // Auto search when dropdown changes
      const apiQuery = this.prepareApiQuery(newQuery);
      this.props.getTKT1C3DInfos(apiQuery);
    });
  }

  handleTrustedPersonChange = (selectedOption) => {
    const newQuery = { 
      ...this.state.query, 
      trusted_person_id: selectedOption ? selectedOption.value : '' 
    };
    this.setState({ query: newQuery }, () => {
      // Auto search when dropdown changes
      const apiQuery = this.prepareApiQuery(newQuery);
      this.props.getTKT1C3DInfos(apiQuery);
    });
  }

  handleTaxCityFilterChange = (e) => {
    const newQuery = { 
      ...this.state.query, 
      tax_city_filter: e.target.value 
    };
    this.setState({ query: newQuery });
  }

  handleSelectSort = (e) => {
    const newQuery = { ...this.state.query, sortBy: e.target.value };
    this.setState({ query: newQuery });
  }

  handleSelectSortOrder = (e) => {
    const newQuery = { ...this.state.query, sortOrder: parseInt(e.target.value) };
    this.setState({ query: newQuery });
  }

  handleColumnToggle = (columnKey) => {
    this.setState(prevState => {
      const newShowColumns = {
        ...prevState.showColumns,
        [columnKey]: !prevState.showColumns[columnKey]
      };
      
      // Save view config to localStorage
      localStorage.setItem('TKT1ValidC3D_ViewConfig', JSON.stringify(newShowColumns));
      
      return { showColumns: newShowColumns };
    })
  }

  // Map gender from English to Vietnamese
  mapGender = (gender) => {
    if (!gender) return '-';
    switch (gender.toUpperCase()) {
      case 'MALE':
        return 'Nam';
      case 'FEMALE':
        return 'Nữ';
      default:
        return gender;
    }
  }

  // Map Etsy status to Vietnamese
  mapEtsyStatus = (status) => {
    if (!status) return '-';
    switch (status.toUpperCase()) {
      case 'NO_TAX_INFO':
        return 'Chưa có thông tin thuế';
      case 'WAIT_FOR_TRUSTED_INFO':
        return 'Chờ thông tin người tin cậy';
      case 'FOUND_TRUSTED_INFO':
        return 'Đã tìm thấy người tin cậy';
      case 'REGISTERED':
        return 'Đã đăng ký';
      case 'SUSPENDED':
        return 'Bị tạm dừng';
      case 'CANCEL':
        return 'Đã hủy';
      default:
        return status;
    }
  }

  // Extract tax cities from DN_tax_infos and TNCN_tax_infos
  getTaxCities = (info) => {
    if (!info) return '-';
    
    const cities = new Set();
    
    // Extract cities from DN_tax_infos
    if (info.DN_tax_infos && Array.isArray(info.DN_tax_infos)) {
      info.DN_tax_infos.forEach(taxInfo => {
        if (taxInfo.city && taxInfo.city.trim()) {
          cities.add(taxInfo.city.trim());
        }
      });
    }
    
    // Extract cities from TNCN_tax_infos
    if (info.TNCN_tax_infos && Array.isArray(info.TNCN_tax_infos)) {
      info.TNCN_tax_infos.forEach(taxInfo => {
        if (taxInfo.city && taxInfo.city.trim()) {
          cities.add(taxInfo.city.trim());
        }
      });
    }
    
    return cities.size > 0 ? Array.from(cities).join(' | ') : '-';
  }

  // Extract all unique tax cities from C3D data
  extractTaxCityOptions = (c3dInfos) => {
    if (!c3dInfos || !Array.isArray(c3dInfos)) return [];
    
    const cities = new Set();
    
    c3dInfos.forEach(info => {
      // Extract cities from DN_tax_infos
      if (info.DN_tax_infos && Array.isArray(info.DN_tax_infos)) {
        info.DN_tax_infos.forEach(taxInfo => {
          if (taxInfo.city && taxInfo.city.trim()) {
            cities.add(taxInfo.city.trim());
          }
        });
      }
      
      // Extract cities from TNCN_tax_infos
      if (info.TNCN_tax_infos && Array.isArray(info.TNCN_tax_infos)) {
        info.TNCN_tax_infos.forEach(taxInfo => {
          if (taxInfo.city && taxInfo.city.trim()) {
            cities.add(taxInfo.city.trim());
          }
        });
      }
    });
    
    return Array.from(cities).sort().map(city => ({
      value: city,
      label: city
    }));
  }

  // Copy text to clipboard
  copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      console.log('Copied to clipboard:', text);
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  }

  // Format date to DD/MM/YYYY, handling both ISO strings and DD/MM/YYYY strings
  formatDate = (dateString) => {
    if (!dateString) return '-';
    
    // If already in DD/MM/YYYY format, return as is
    if (typeof dateString === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
      return dateString;
    }
    
    // Try to parse as ISO date or other formats
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) {
        return dateString; // Return original if can't parse
      }
      
      // Convert to Hanoi timezone (UTC+7) for display
      const hanoiDate = new Date(date.getTime() + (7 * 60 * 60 * 1000));
      return hanoiDate.toLocaleDateString('en-GB');
    } catch (error) {
      return dateString; // Return original if error
    }
  }

  // Modal handlers
  handleViewClick = (c3dInfo) => {
    this.setState({
      showViewModal: true,
      selectedC3DInfo: c3dInfo,
      isEditMode: false
    });
  }

  handleEditClick = (c3dInfo) => {
    this.setState({
      showEditModal: true,
      selectedC3DInfo: c3dInfo,
      isEditMode: true
    });
  }

  handleCloseViewModal = () => {
    this.setState({
      showViewModal: false,
      selectedC3DInfo: null,
      isEditMode: false
    });
  }

  handleCloseEditModal = () => {
    this.setState({
      showEditModal: false,
      selectedC3DInfo: null,
      isEditMode: false
    });
  }

  handleSaveEdit = async (formData) => {
    try {
      const { selectedC3DInfo } = this.state;
      
      if (!selectedC3DInfo || !selectedC3DInfo._id) {
        alert('Không tìm thấy thông tin C3D để cập nhật');
        return;
      }

      // Prepare update data - only include fields that can be edited
      const updateData = {
        full_name: formData.full_name,
        full_name_english: formData.full_name_english,
        c3d_dob: formData.c3d_dob,
        c3d_sex: formData.c3d_sex,
        c3d_place_of_origin: formData.c3d_place_of_origin,
        c3d_place_of_residence: formData.c3d_place_of_residence,
        c3d_city: formData.c3d_city,
        cmt_number: formData.cmt_number,
        c3d_issue_date: formData.c3d_issue_date,
        c3d_expired_date: formData.c3d_expired_date,
        source: formData.source,
        info_etsy_status: formData.info_etsy_status,
        ref_trusted_person_mid: formData.ref_trusted_person_mid,
        note: formData.note
      };

      // Call the update action
      await this.props.updateTKT1C3DInfo(selectedC3DInfo._id, updateData);
      
      // Show success message
      alert('Cập nhật thông tin C3D thành công!');
      
      // Close modal
      this.handleCloseEditModal();
      
      // Refresh the data
      const apiQuery = this.prepareApiQuery(this.state.query);
      this.props.getTKT1C3DInfos(apiQuery);
      
    } catch (error) {
      console.error('Error updating C3D info:', error);
      alert('Lỗi khi cập nhật thông tin C3D: ' + (error.message || 'Unknown error'));
    }
  }

  // Open tax lookup links
  openTaxKDLink = (c3Number) => {
    if (c3Number) {
      const url = `https://tracuunnt.gdt.gov.vn/tcnnt/mstdn.jsp?mst=${c3Number}`;
      window.open(url, '_blank');
    }
  }

  // Open C3D database search link in iframe modal
  openC3DSearchLink = (fullNameEnglish, mid) => {
    if (fullNameEnglish && mid) {
      const encodedName = encodeURIComponent(fullNameEnglish);
      const url = `/admin/tkt1/c3d-database?search=${encodedName}&search_exact=true&ref_trusted_person_mid=${mid}`;
      this.setState({
        showIframeModal: true,
        iframeUrl: url,
        iframeTitle: `C3D Database Search - ${fullNameEnglish}`
      });
    }
  }

  // Handle MID click - show trusted person info modal
  handleMIDClick = async (mid) => {
    if (!mid) return;

    try {
      const token = getToken();
      const response = await fetch(`${getApiUrl()}/api/tkt1-trusted-person-info/mid/${mid}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const trustedPersonData = await response.json();
        this.setState({
          showTrustedPersonModal: true,
          selectedTrustedPersonInfo: trustedPersonData.data
        });
      } else {
        console.error('Failed to fetch trusted person info');
        alert('Không thể tải thông tin người tin cậy');
      }
    } catch (error) {
      console.error('Error fetching trusted person info:', error);
      alert('Lỗi khi tải thông tin người tin cậy');
    }
  }

  // Close trusted person modal
  handleCloseTrustedPersonModal = () => {
    this.setState({
      showTrustedPersonModal: false,
      selectedTrustedPersonInfo: null
    });
  }

  handleEtsyInfoPackClick = (refEtsyInfoPackMid) => {
    if (refEtsyInfoPackMid) {
      this.setState({
        showIframeModal: true,
        iframeUrl: `/admin/tkt1-etsy/etsy-info-pack-detail/${refEtsyInfoPackMid}`,
        iframeTitle: `Etsy Info Pack Detail - ${refEtsyInfoPackMid}`
      });
    }
  }

  handleCloseIframeModal = () => {
    this.setState({
      showIframeModal: false,
      iframeUrl: '',
      iframeTitle: ''
    });
  }

  // Helper function to prepare API query
  prepareApiQuery = (query) => {
    const { showColumns, search, relation_with, trusted_person_id, tax_city_filter, ...baseQuery } = query;
    const apiQuery = {
      ...baseQuery,
      search: search ? search.trim() : '',
      has_ref_trusted_person_mid: true // Only show C3D records that have ref_trusted_person_mid
    };
    
    // Add relation filter if selected
    if (relation_with && relation_with.trim()) {
      apiQuery.relation_with = relation_with;
    }
    
    // Add trusted person filter if selected
    if (trusted_person_id && trusted_person_id.trim()) {
      // Find the MID of selected trusted person
      const selectedPerson = this.state.trustedPersonOptions.find(p => p.value === trusted_person_id);
      if (selectedPerson) {
        apiQuery.ref_trusted_person_mid = selectedPerson.mid;
      }
    }
    
    return apiQuery;
  }

  // Client-side filter for tax city
  filterC3DInfosByTaxCity = (c3dInfos, taxCityFilter) => {
    if (!taxCityFilter || !taxCityFilter.trim()) {
      return c3dInfos;
    }
    
    return c3dInfos.filter(info => {
      const taxCities = this.getTaxCities(info);
      return taxCities.toLowerCase().includes(taxCityFilter.toLowerCase());
    });
  }

  // Get filtered count for display
  getFilteredCount = () => {
    const { c3dInfos } = this.props;
    const { query } = this.state;
    
    let safeC3dInfos = Array.isArray(c3dInfos) ? c3dInfos.filter(info => info != null && typeof info === 'object') : [];
    safeC3dInfos = this.filterC3DInfosByTaxCity(safeC3dInfos, query.tax_city_filter);
    
    return safeC3dInfos.length;
  }

  handleChangeItemsPerPage = (e) => {
    const itemsPerPage = parseInt(e.target.value);
    const trimmedQuery = {
      ...this.state.query,
      itemsPerPage,
      currentPage: 1,
      search: this.state.query.search.trim()
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    
    // Save to localStorage
    localStorage.setItem('TKT1ValidC3D_itemsPerPage', JSON.stringify(itemsPerPage));
    
    this.setState({
      query: { ...this.state.query, itemsPerPage, currentPage: 1 }
    }, () => {
      this.props.getTKT1C3DInfos(apiQuery);
    })
  }

  handleSubmit = (e) => {
    if (e) {
      e.preventDefault();
    }
    this.handleSearch();
  }

  handleSearch = () => {
    const trimmedQuery = {
      ...this.state.query,
      search: this.state.query.search.trim()
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    
    this.props.getTKT1C3DInfos(apiQuery);
  }

  updatePage = (itemOffset, newPage) => {
    if (newPage == this.state.query.currentPage)
      return;

    const trimmedQuery = {
      ...this.state.query,
      currentPage: newPage,
      search: this.state.query.search.trim()
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);

    this.setState({
      query: { ...this.state.query, currentPage: newPage },
    }, () => {
      this.setState({ c3dInfos: [] }, () => {
        this.props.getTKT1C3DInfos(apiQuery);
      })
    })
  }

  renderSearchFilter = () => {
    return <>
      <Row className="mb-3">
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Đầu mối</InputGroup.Text>
            <Form.Select
              value={this.state.query.relation_with}
              onChange={this.handleRelationChange}
            >
              <option value="">Tất cả</option>
              {this.state.relationOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="3">
          <InputGroup>
            <InputGroup.Text>Trusted Person</InputGroup.Text>
            <div style={{ flex: 1 }}>
              <Select
                value={this.state.trustedPersonOptions.find(option => option.value === this.state.query.trusted_person_id) || null}
                onChange={this.handleTrustedPersonChange}
                options={this.state.trustedPersonOptions}
                placeholder="Chọn Trusted Person..."
                isClearable
                isSearchable
                noOptionsMessage={() => "Không tìm thấy"}
                filterOption={(option, inputValue) => {
                  const searchTerm = inputValue.toLowerCase();
                  const mid = option.data.mid ? option.data.mid.toLowerCase() : '';
                  const name = option.data.label ? option.data.label.toLowerCase() : '';
                  return mid.includes(searchTerm) || name.includes(searchTerm);
                }}
                formatOptionLabel={(option) => (
                  <div>
                    <strong>[{option.mid}]</strong> {option.label}
                  </div>
                )}
                styles={{
                  control: (provided) => ({
                    ...provided,
                    minHeight: '38px',
                    border: 'none',
                    boxShadow: 'none'
                  }),
                  container: (provided) => ({
                    ...provided,
                    flex: 1
                  })
                }}
              />
            </div>
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Tax City</InputGroup.Text>
            <Form.Select
              value={this.state.query.tax_city_filter}
              onChange={this.handleTaxCityFilterChange}
            >
              <option value="">Tất cả</option>
              {this.state.taxCityOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup className="mb-3">
            <InputGroup.Text>Tìm kiếm</InputGroup.Text>
            <Form.Control
              defaultValue=""
              value={this.state.query.search}
              onChange={this.handleChangeSearch}
              onKeyPress={this.handleKeyPress}
              placeholder="Tìm kiếm theo tên, C3D number..."
              aria-label="search"
              aria-describedby="basic-addon1"
            />
            {this.state.query.search && (
              <InputGroup.Text
                onClick={this.handleClearSearch}
                style={{
                  cursor: 'pointer',
                  backgroundColor: 'transparent',
                  borderLeft: 'none'
                }}
                title="Xóa tìm kiếm"
              >
                <FaTimes size={12} />
              </InputGroup.Text>
            )}
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Sắp xếp theo</InputGroup.Text>
            <Form.Select
              value={this.state.query.sortBy}
              onChange={this.handleSelectSort}
            >
              <option value="created_at">Ngày tạo</option>
              <option value="updated_at">Ngày cập nhật</option>
              <option value="full_name">Tên đầy đủ</option>
              <option value="c3d_number">Số C3D</option>
              <option value="c3d_dob">Ngày sinh</option>
              <option value="ref_trusted_person_mid">Người tin cậy</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="1" className="d-flex align-items-center justify-content-end">
          <Button
            className="btn-fill btn"
            type="submit"
            variant="primary"
            onClick={this.handleSubmit}
          >
            Tìm kiếm
          </Button>
        </Col>
      </Row>
    </>
  }

  renderC3DInfoTable = () => {
    const { c3dInfos } = this.props;
    const { showColumns, query } = this.state;
    
    let safeC3dInfos = Array.isArray(c3dInfos) ? c3dInfos.filter(info => info != null && typeof info === 'object') : [];
    
    // Apply client-side tax city filter
    safeC3dInfos = this.filterC3DInfosByTaxCity(safeC3dInfos, query.tax_city_filter);
    
    if (!safeC3dInfos || safeC3dInfos.length === 0) {
      return (
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th style={{ width: '60px' }}>STT</th>
              {showColumns.full_name && <th>Tên đầy đủ</th>}
              {showColumns.full_name_english && <th>Tên tiếng Anh</th>}
              {showColumns.c3d_number && <th>Số C3D</th>}
              {showColumns.c3d_dob && <th>Ngày sinh</th>}
              {showColumns.c3d_sex && <th>Giới tính</th>}
              {showColumns.c3d_place_of_origin && <th>Nơi sinh</th>}
              {showColumns.c3d_place_of_residence && <th>Nơi cư trú</th>}
              {showColumns.c3d_city && <th>Thành phố</th>}
              {showColumns.tax_city && <th>Tax City</th>}
              {showColumns.source && <th>Nguồn</th>}
              {showColumns.info_etsy_status && <th>Trạng thái Etsy</th>}
              {showColumns.ref_trusted_person_mid && <th>MID người tin cậy</th>}
              {showColumns.ref_etsy_info_pack_mid && <th>MID Etsy Info Pack</th>}
              {showColumns.cmt_number && <th>Số CMT</th>}
              {showColumns.c3d_issue_date && <th>Ngày cấp C3D</th>}
              {showColumns.c3d_expired_date && <th>Ngày hết hạn C3D</th>}
              <th style={{ width: '100px' }}>Thao tác</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan={Object.values(showColumns).filter(Boolean).length + 2} className="text-center">
                {this.state.loading ? 'Đang tải...' : 'Không có dữ liệu'}
              </td>
            </tr>
          </tbody>
        </Table>
      );
    }
    
    return (
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th style={{ width: '60px' }}>STT</th>
            {showColumns.full_name && <th>Tên đầy đủ</th>}
            {showColumns.full_name_english && <th>Tên tiếng Anh</th>}
            {showColumns.c3d_number && <th>Số C3D</th>}
            {showColumns.c3d_dob && <th>Ngày sinh</th>}
            {showColumns.c3d_sex && <th>Giới tính</th>}
            {showColumns.c3d_place_of_origin && <th>Nơi sinh</th>}
            {showColumns.c3d_place_of_residence && <th>Nơi cư trú</th>}
            {showColumns.c3d_city && <th>Thành phố</th>}
            {showColumns.tax_city && <th>Tax City</th>}
            {showColumns.source && <th>Nguồn</th>}
            {showColumns.info_etsy_status && <th>Trạng thái Etsy</th>}
            {showColumns.ref_trusted_person_mid && <th>MID người tin cậy</th>}
            {showColumns.ref_etsy_info_pack_mid && <th>MID Etsy Info Pack</th>}
            {showColumns.cmt_number && <th>Số CMT</th>}
            {showColumns.c3d_issue_date && <th>Ngày cấp C3D</th>}
            {showColumns.c3d_expired_date && <th>Ngày hết hạn C3D</th>}
            <th style={{ width: '100px' }}>Thao tác</th>
          </tr>
        </thead>
        <tbody>
          {safeC3dInfos.map((info, index) => {
            if (!info || typeof info !== 'object') return null;
              
              return (
                <tr key={info._id || index}>
                  <td>{(this.state.query.currentPage - 1) * this.state.query.itemsPerPage + index + 1}</td>
                  {showColumns.full_name && (
                    <td>
                      <div className="fw-bold">{info.full_name || '-'}</div>
                    </td>
                  )}
                  {showColumns.full_name_english && (
                    <td>{info.full_name_english || '-'}</td>
                  )}
                  {showColumns.c3d_number && (
                    <td>
                      {info.c3d_number ? (
                        <div className="d-flex align-items-center gap-2">
                          <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>{info.c3d_number}</Badge>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(info.c3d_number)}
                            title="Copy C3D number"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.c3d_dob && (
                    <td>
                      {this.formatDate(info.c3d_dob)}
                    </td>
                  )}
                  {showColumns.c3d_sex && (
                    <td>{this.mapGender(info.c3d_sex)}</td>
                  )}
                  {showColumns.c3d_place_of_origin && (
                    <td>
                      <div style={{ whiteSpace: 'nowrap' }} 
                           title={info.c3d_place_of_origin}>
                        {info.c3d_place_of_origin || '-'}
                      </div>
                    </td>
                  )}
                  {showColumns.c3d_place_of_residence && (
                    <td>
                      <div style={{ whiteSpace: 'nowrap' }} 
                           title={info.c3d_place_of_residence}>
                        {info.c3d_place_of_residence || '-'}
                      </div>
                    </td>
                  )}
                  {showColumns.c3d_city && (
                    <td>{info.c3d_city || '-'}</td>
                  )}
                  {showColumns.tax_city && (
                    <td>
                      <div style={{ whiteSpace: 'nowrap' }} 
                           title={this.getTaxCities(info)}>
                        {this.getTaxCities(info)}
                      </div>
                    </td>
                  )}
                  {showColumns.source && (
                    <td>{info.source || '-'}</td>
                  )}
                  {showColumns.info_etsy_status && (
                    <td>
                      {info.info_etsy_status ? (
                        <Badge 
                          bg={
                            info.info_etsy_status === 'REGISTERED' ? 'success' :
                            info.info_etsy_status === 'SUSPENDED' ? 'danger' :
                            info.info_etsy_status === 'CANCEL' ? 'secondary' :
                            info.info_etsy_status === 'FOUND_TRUSTED_INFO' ? 'info' :
                            info.info_etsy_status === 'WAIT_FOR_TRUSTED_INFO' ? 'warning' :
                            'light'
                          }
                          style={{ fontSize: '0.8em', padding: '4px 8px' }}
                        >
                          {this.mapEtsyStatus(info.info_etsy_status)}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.ref_trusted_person_mid && (
                    <td>
                      {info.ref_trusted_person_mid ? (
                        <Badge 
                          bg="primary" 
                          style={{ 
                            fontSize: '0.9em', 
                            padding: '6px 10px',
                            cursor: 'pointer'
                          }}
                          onClick={() => this.handleMIDClick(info.ref_trusted_person_mid)}
                          title="Xem thông tin người tin cậy"
                        >
                          {info.ref_trusted_person_mid}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.ref_etsy_info_pack_mid && (
                    <td>
                      {info.ref_etsy_info_pack_mid ? (
                        <Badge 
                          bg="success" 
                          style={{ 
                            fontSize: '0.9em', 
                            padding: '6px 10px', 
                            cursor: 'pointer' 
                          }}
                          onClick={() => this.handleEtsyInfoPackClick(info.ref_etsy_info_pack_mid)}
                          title="Click để xem chi tiết Etsy Info Pack"
                        >
                          {info.ref_etsy_info_pack_mid}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.cmt_number && (
                    <td>{info.cmt_number || '-'}</td>
                  )}
                  {showColumns.c3d_issue_date && (
                    <td>
                      {this.formatDate(info.c3d_issue_date)}
                    </td>
                  )}
                  {showColumns.c3d_expired_date && (
                    <td>
                      {this.formatDate(info.c3d_expired_date)}
                    </td>
                  )}
                  <td>
                    <div className="d-flex align-items-center gap-2">
                      <div style={{ position: 'relative' }}>
                        <FaEye 
                          size={16} 
                          style={{ 
                            cursor: 'pointer', 
                            color: '#6c757d'
                          }}
                          title="Xem thông tin"
                          onClick={() => this.handleViewClick(info)}
                        />
                        {info.last_checked_tax && (
                          <span 
                            style={{
                              position: 'absolute',
                              top: '-4px',
                              right: '-4px',
                              width: '12px',
                              height: '12px',
                              backgroundColor: '#28a745',
                              borderRadius: '50%',
                              border: '2px solid white'
                            }}
                            title="Đã kiểm tra thuế"
                          />
                        )}
                      </div>
                      <FaEdit 
                        size={16} 
                        style={{ 
                          cursor: 'pointer', 
                          color: '#6c757d'
                        }}
                        title="Chỉnh sửa"
                        onClick={() => this.handleEditClick(info)}
                      />
                    </div>
                  </td>
                </tr>
              );
            })
          }
        </tbody>
      </Table>
    );
  }

  render() {
    return (
      <>
        <Container fluid>
          <Row className="mb-4">
            <Col>
              <h2 className="text-primary">
                TKT1 Valid C3D
              </h2>
            </Col>
          </Row>
          {this.renderSearchFilter()}
          <Row>
            <Col>
              <h5 className="d-inline-block">
                <b>Tìm thấy <span className='text-danger'>{this.getFilteredCount()}</span> bản ghi:</b>
              </h5>
            </Col>
            <Col className="text-end text-nowrap" md="auto">
              <div className="d-inline-flex align-items-center flex-nowrap">
                <Button 
                  variant="secondary" 
                  size="sm"
                  className="me-2"
                  onClick={() => this.setState({ showConfigModal: true })}
                >
                  <i className="fas fa-cog"></i> Cấu hình hiển thị
                </Button>
                <div className="d-inline-block ms-3">
                  <span className="me-2">Số bản ghi/trang:</span>
                  <Form.Select
                    size="sm"
                    value={this.state.query.itemsPerPage}
                    onChange={this.handleChangeItemsPerPage}
                    style={{ width: '100px', display: 'inline-block' }}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value={200}>200</option>
                    <option value={500}>500</option>
                  </Form.Select>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              {this.renderC3DInfoTable()}
            </Col>
          </Row>
        </Container>
        <Pagination 
          totalItems={this.props.totalCount} 
          itemsPerPage={this.state.query.itemsPerPage} 
          itemOffset={(this.state.query.currentPage - 1) * this.state.query.itemsPerPage} 
          updatePage={this.updatePage} 
        />

        {/* Configuration Modal */}
        <Modal show={this.state.showConfigModal} onHide={() => this.setState({ showConfigModal: false })}>
          <Modal.Header closeButton>
            <Modal.Title>Cấu hình hiển thị</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <div className="mb-3">
                <h6>Hiển thị cột</h6>
                {Object.entries(this.state.showColumns || {}).map(([column, isVisible]) => {
                  const columnLabels = {
                    full_name: 'Tên đầy đủ',
                    full_name_english: 'Tên tiếng Anh',
                    c3d_number: 'Số C3D',
                    c3d_dob: 'Ngày sinh',
                    c3d_sex: 'Giới tính',
                    c3d_place_of_origin: 'Nơi sinh',
                    c3d_place_of_residence: 'Nơi cư trú',
                    c3d_city: 'Thành phố',
                    tax_city: 'Tax City',
                    source: 'Nguồn',
                    info_etsy_status: 'Trạng thái Etsy',
                    ref_trusted_person_mid: 'MID người tin cậy',
                    ref_etsy_info_pack_mid: 'MID Etsy Info Pack',
                    cmt_number: 'Số CMT',
                    c3d_issue_date: 'Ngày cấp C3D',
                    c3d_expired_date: 'Ngày hết hạn C3D'
                  };
                  
                  return (
                    <Form.Check
                      key={column}
                      type="switch"
                      id={`column-${column}`}
                      label={columnLabels[column] || column}
                      checked={isVisible}
                      onChange={() => this.handleColumnToggle(column)}
                      className="mb-2"
                    />
                  );
                })}
              </div>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.setState({ showConfigModal: false })}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* View Modal */}
        <C3DInfoModal
          show={this.state.showViewModal}
          onHide={this.handleCloseViewModal}
          c3dInfo={this.state.selectedC3DInfo}
          isEditMode={false}
        />

        {/* Edit Modal */}
        <C3DInfoModal
          show={this.state.showEditModal}
          onHide={this.handleCloseEditModal}
          c3dInfo={this.state.selectedC3DInfo}
          isEditMode={true}
          onSave={this.handleSaveEdit}
        />

        {/* Iframe Modal */}
        <IframeModal
          show={this.state.showIframeModal}
          onHide={this.handleCloseIframeModal}
          url={this.state.iframeUrl}
          title={this.state.iframeTitle}
          showSidebar={false}
        />

        {/* Trusted Person Info Modal */}
        <TrustedPersonInfoModal
          show={this.state.showTrustedPersonModal}
          onHide={this.handleCloseTrustedPersonModal}
          trustedPersonInfo={this.state.selectedTrustedPersonInfo}
          isEditMode={false}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    c3dInfos: state.tkt1C3DInfoReducer.c3dInfos,
    totalCount: state.tkt1C3DInfoReducer.totalCount,
    trustedPersonInfos: state.tkt1TrustedPersonReducer.trustedPersonInfos
  };
};

export default connect(mapStateToProps, { getTKT1C3DInfos, getTKT1TrustedPersonInfos, updateTKT1C3DInfo })(TKT1ValidC3D);
